const downloadBlob = (data: BlobPart, filename: string, mime = 'text/csv') => {
  const url = URL.createObjectURL(new Blob([data], { type: mime }))
  const a = Object.assign(document.createElement('a'), { href: url, download: filename })
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

const generateFilename = (type: string, extension = 'csv') => {
  const date = new Date().toISOString().split('T')[0]
  return `export_${type}_${date}.${extension}`
}

export { downloadBlob, generateFilename }
